import React from "react";

import { DialogContent } from "@mui/material";

import { WideDialog } from "../MainModalSimple/styles";
import { ModalTransition } from "../ModalTransition";

import { ModalBaseType } from "../../types/common";

export default function MainModalBase({ onClose, children }: ModalBaseType) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={handleClose}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>{children}</DialogContent>
    </WideDialog>
  );
}
